<!-- AlertDialog.vue -->
<template>
	<div v-if="show" class="alert-dialog">
		<div class="alert-dialog-content">
			<slot></slot>
			<!-- 使用插槽来插入提示内容 -->
		</div>
		<button class="button" @click="close">关闭</button>
	</div>
</template>

<script>
export default {
	name: 'AlertDialog',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		close() {
			this.$emit('closeAlert') // 通知父组件关闭弹窗
		},
	},
}
</script>

<style scoped>
.alert-dialog {
	position: fixed;
	top: 30%;
	left: 50%;
	transform: translate(-50%, -50%);
	background-color: #fff;
	border: 1px solid #ccc;
	padding: 20px;
	z-index: 1000;
	width: 280px;
	height: 120px;
}

.alert-dialog-content {
	/* 样式根据需求自定义 */
	font-weight: 400;
	font-size: 14px;
	color: var(--timeTitleColor);
	line-height: 28px;
	text-align: left;
	font-style: normal;
}
.button {
	color: #fff;
	background-color: #409eff;
	border-color: #409eff;

	display: inline-block;
	line-height: 1;
	white-space: nowrap;
	cursor: pointer;
	text-align: center;
	box-sizing: border-box;
	outline: 0;
	margin: 0;
	transition: 0.1s;
	font-weight: 500;
	padding: 7px 15px;
	font-size: 12px;
	border-radius: 3px;
	position: absolute;
	bottom: 10px;
	right: 15px;
}
</style>
